import { getListItems } from "./getListItems.js";
import { getParentListItem } from "./getParentListItem.js";
import { getPrevSibling } from "./getPrevSibling.js";
import { isAtStartOfListItem } from "./isAtStartOfListItem.js";
/**
 * Check if `editor.deleteBackward()` is safe to call (it won't break the structure).
 */
export function isDeleteBackwardAllowed(editor, schema) {
  let at = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : editor.selection;
  const listItemsInSelection = getListItems(editor, schema, at);
  if (listItemsInSelection.length === 0) {
    return true;
  }
  const [[, listItemPath]] = listItemsInSelection;
  const isInNestedList = getParentListItem(editor, schema, listItemPath) !== null;
  const isFirstListItem = getPrevSibling(editor, listItemPath) === null;
  return isInNestedList || !isFirstListItem || !isAtStartOfListItem(editor, schema);
}